import type { IndexedEntity } from "metabase-types/api";

import { slugify } from "./utils";

export const indexedEntity = (entity: IndexedEntity) =>
  `/model/${entity.model_id}-${slugify(entity.model_name)}/${entity.id}`;
